import React, { lazy, Suspense } from 'react';
import { Alert, Card, CardHeader, Skeleton } from '@opendate-app/setlist';
import TrendBadge from '../TrendBadge';
import { compactCurrency } from '../../utils/reportingUtils';

const RevenueStreamChart = lazy(() => import('./RevenueStreamChart'));

const chartSkeleton = <Skeleton width="100%" height={260} radius={8} />;

function RevenueByStreamCard({ data, loading, error, comparisonLabel, href, yearOverYear }) {
  return (
    <Card header={<CardHeader title={<a href={href} style={{ color: 'inherit' }}>Revenue by stream →</a>} />}>
      {loading && chartSkeleton}
      {!loading && error && <Alert color="error" title="Couldn't load revenue" description="Refresh the page to try again." />}
      {!loading && !error && (
        <>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap', marginBottom: 8 }}>
            <span style={{ fontSize: 28, fontWeight: 700, color: 'var(--sl-text-primary)' }}>{compactCurrency(data?.total_current || 0)}</span>
            <TrendBadge current={data?.total_current} prior={data?.total_prior} label={comparisonLabel} />
          </div>
          {yearOverYear && data?.total_last_year != null && (
            <div style={{ marginBottom: 8 }}>
              <TrendBadge current={data.total_current} prior={data.total_last_year} label="vs same period last year" />
            </div>
          )}
          <Suspense fallback={chartSkeleton}>
            <RevenueStreamChart days={data?.days || []} granularity={data?.granularity} />
          </Suspense>
        </>
      )}
    </Card>
  );
}

export default RevenueByStreamCard;
